"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastTagState = exports.FastTagType = void 0;
var FastTagType;
(function (FastTagType) {
    FastTagType["EBAY"] = "egd";
    FastTagType["FACEBOOK"] = "facebook";
    FastTagType["SHOPIFY"] = "shopify";
    FastTagType["WALMART"] = "walmart";
    FastTagType["GOOGLE"] = "google";
    FastTagType["SFP"] = "sfp";
    FastTagType["WISH"] = "wish";
})(FastTagType = exports.FastTagType || (exports.FastTagType = {}));
var FastTagState;
(function (FastTagState) {
    FastTagState["ACTIVATED"] = "activated";
    FastTagState["DEACTIVATED"] = "deactivated";
    FastTagState["INVALID"] = "invalid";
})(FastTagState = exports.FastTagState || (exports.FastTagState = {}));
//# sourceMappingURL=FastTag.js.map